import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Mobile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.48 2H9.53C7.7 2 6.21 3.49 6.21 5.32v21.93a3.04 3.04 0 0 0 3.03 2.74h13.25c.87 0 1.66-.34 2.25-.89l.09-.07.09-.12c.54-.56.88-1.33.89-2.18V5.32c0-1.83-1.49-3.32-3.32-3.32Zm-6.47 26.13h-.02a1.419 1.419 0 1 1 1.42-1.42c0 .18-.03.34-.09.5-.19.54-.71.92-1.31.92M9 5.32c0-.29.23-.52.52-.52h12.95c.29 0 .52.23.52.52v18.2c-.09 0-.19-.01-.3-.01s-.21 0-.31.01H8.99V5.32Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23 31.86H9.29c-1.89 0-3.43-1.54-3.43-3.43V3.29C5.86 1.4 7.4-.14 9.29-.14H23c1.89 0 3.43 1.54 3.43 3.43v25.14c0 1.89-1.54 3.43-3.43 3.43M9.29 2.14c-.63 0-1.14.51-1.14 1.14v25.14c0 .63.51 1.14 1.14 1.14H23c.63 0 1.14-.51 1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H9.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.29 6.71H15a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
MobileIcon.displayName = 'MobileIcon';